import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Navigation } from './navigation'
import { initLenis, scrollToStart } from './lenis'
import { initSwiper } from './swiper'
import { initAlpine } from './alpine'
import { initAnimations, Flags } from './animation'
import { initFeatures } from './features'
import { initFeaturesAlt } from './featuresAlt'
import { initPricing } from './pricing'
import { initTestimonials } from './testimonials'
import { initScrollingCards } from './scrollingCards'
import { articles } from './articles'
import { splitText } from './splitText'
import { background } from './background'
import { linkToSections } from './linkToSections'
import { cookieBanner } from './cookies'
import { initForms } from './formie'
import { parallaxOnScroll, parallaxOnMouse } from './parallax'
import { setTheme, setHeaderWidth, autoplayVideos, generateContentsList, creditBgn } from './utilities'

gsap.registerPlugin(ScrollTrigger)

const initBarba = () => {

	window.initialLoad = true

	const nav = new Navigation()

	barba.init({
		debug: false,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'fade-transition',
				once(data) { },
				leave(data) {
					return gsap.to(data.current.container, {
						opacity: 0
					})
				},
				afterLeave() {
					scrollToStart()
					nav.closeNavigation()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
					return gsap.from(data.next.container, {
						opacity: 0
					})
				}
			}
		]
	})

	barba.hooks.once((data) => {
		setTheme()
		setHeaderWidth()
		splitText()
		initLenis()
		initAlpine() 
		initSwiper()
		initFeatures()
		initPricing()
		initScrollingCards()
		initAnimations()
		initFeaturesAlt()
		initTestimonials()
		Flags()
		parallaxOnMouse()
		parallaxOnScroll()
		generateContentsList()
		linkToSections()
		autoplayVideos(data.next.container)
		articles()
		cookieBanner()
		creditBgn()

		
		window.onload = function() {
			window.initialLoad = false
			document.documentElement.classList.add('is-ready')
			
			setTimeout(() => {
				background()
			}, 2000)
			
			setTimeout(() => ScrollTrigger.refresh(), 2500)
		}
	})

	barba.hooks.enter((data) => {
		if (htmx) {
			htmx.process(data.next.container)
		}
	})

	barba.hooks.after((data) => {
		splitText()
		initSwiper()
		initAnimations()
		initFeatures()
		initPricing()
		initScrollingCards()
		initFeaturesAlt()
		initTestimonials()
		Flags()
		parallaxOnMouse()
		parallaxOnScroll()
		generateContentsList()
		linkToSections()
		articles()
		initForms()
		autoplayVideos(data.next.container)

		setTimeout(() => ScrollTrigger.refresh(), 2500)
	})
}

export default initBarba